import { FC, useEffect } from 'react'
import { translate } from '../index'
import { Form, Input, Modal } from 'antd'
import { SendOutlined } from '@ant-design/icons'
import { SendEmailAttachments } from './SendEmailAttachments'
import { ShowIf } from './ShowIf'

type OrderSendEmailProps = {
  open: boolean
  onCancel: () => void
  onSend: (input: SendEmailInput) => void
  sending: boolean
  attachment?: {
    enabled: boolean
    prefix: string
  }
  data?: Partial<SendEmailInput>
  emailInputEnabled?: {
    email?: string
    subject?: string
    text?: string
  }
}

export type SendEmailInput = {
  subject: string
  text: string
  email: string
  attachments?: string[]
}

export const SendEmail: FC<OrderSendEmailProps> = ({open, onCancel, onSend, sending, attachment, data, emailInputEnabled}) => {    
  const [form] = Form.useForm<SendEmailInput>()

  useEffect(() => {
    if (emailInputEnabled?.email) {
      form.setFieldsValue({ email: emailInputEnabled?.email ?? undefined })
    }
    if (emailInputEnabled?.subject) {
      form.setFieldsValue({ subject: emailInputEnabled?.subject ?? undefined })
    }
    if (emailInputEnabled?.text) {
      form.setFieldsValue({ text: emailInputEnabled?.text ?? undefined })
    }
  }, [emailInputEnabled?.email, emailInputEnabled?.subject, emailInputEnabled?.text])

  form.setFieldsValue(data ?? {})

  return (
    <>
      <Modal
        open={open}
        title={translate('send', 'email')}
        width='30%'
        onCancel={onCancel}
        onOk={form.submit}
        okButtonProps={{
          icon: <SendOutlined/>,
          loading: sending,
        }}
        okText={translate('send')}
        cancelButtonProps={{
          hidden: true,
        }}
      >
        <Form
          name='sendEmail'
          layout='vertical'
          form={form}
          onFinish={onSend}
        >
          <ShowIf
            condition={!!emailInputEnabled}
            replacement={<></>}
          >
            <Form.Item
              label={translate('email')}
              name='email'
              rules={[
                {
                  type: 'email',
                  message: translate('email_invalid_message'),
                }
              ]}
            >
              <Input/>
            </Form.Item>
          </ShowIf>

          <Form.Item
            label={translate('subject')}
            name='subject'
          >
            <Input/>
          </Form.Item>

          <Form.Item
            label={translate('text')}
            name='text'
          >
            <Input.TextArea
              rows={5}
              style={{
                whiteSpace: 'pre-wrap',
                fontSize: '14px'
              }}
            />
          </Form.Item>

          <ShowIf
            condition={!!attachment?.enabled}
            replacement={<></>}
          >
            <Form.Item
              name='attachments'
            >
              <SendEmailAttachments
                prefix={attachment?.prefix}
              />
            </Form.Item>
          </ShowIf>
        </Form>
      </Modal>
    </>
  )
}